// eslint-disable-next-line no-shadow
export enum FirebaseErrors {
	USER_NOT_FOUND = 'user_not_found',
	EMAIL_ALREADY_IN_USE = 'email_already_in_use',
	INVALID_EMAIL = 'invalid_email',
	INVALID_LOGIN_CREDENTIALS = 'invalid_credential',
	EMAIL_NOT_VERIFIED = 'email_not_verified',
}
